import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 80px 0;
  @media(max-width: 1200px) {
    padding: 40px 0;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1600px;
  width: 100%;
  margin: auto;
  padding: 0px 30px;
  div {
    padding-left: 80px;
    margin-right: auto;
    margin-left: auto;
    @media(max-width: 1600px) {
      margin-right: auto;
    }
    @media(max-width: 1440px) {
      padding-left: 20px;
      padding-right: 20px;
    }
    @media(max-width: 1200px) {
      max-width: none;
      padding-left: 0px;
      padding-right: 0px;
    }
    h2 {
      font-family: 'raleway', san-serif;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      letter-spacing: 0.01em;
      line-height: 60px;
      margin-bottom: 20px;

      span {
        color: #D62027;
        font-size: 60px;
        font-style: normal;
        font-weight: 800;
        letter-spacing: 0.01em;
      }
      @media (max-width: 768px) {
        font-size: 35px;
        margin-bottom: 10px;
        line-height: initial;
        span {
          font-size: 40px;
        }
      }
    }

    p.desc {
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.01em;
      line-height: 24px;
      strong {
        font-weight: 700;
      }
    }

    ul {
      font-size: 29px;
      margin-top: 10px;
      
      @media(max-width: 1200px) {
        margin-top: 0;
      }
      @media (max-width: 768px) {
        font-size: 18px;
        }
      li {
        display: flex;
        align-items: center;
        font-weight: 400;
        border-bottom: 1px solid #E7E7E7;
        padding: 20px 0px;
        &:last-child {
          border-bottom: 0px;
        }
        @media (max-width: 768px) {
          margin-top: 20px;
        }
        p {
          font-size: 16px;
          line-height: 24px;
          strong {
            font-weight: 700;
          }
          @media (max-width: 768px) {
            font-size: 14px;
          }
        }
        img {
          margin-right: 20px;
          @media (max-width: 768px) {
            margin-right: 15px;
          }
        }
      }
    }
  }
  > img {
    @media(max-width: 1200px) {
      display: none;
    }
  }
`;
